import { View } from '@react-pdf/renderer';
import IconPoint from '@components/MbtiPdfReporterMobile/components/IconPoint';
import { fontSize } from '@components/PdfReporter/utils/fontSize';
import { usePdfType } from '@components/MbtiPdfReporterMobile/utils/styles';

function Section(props: { head: any; children: any; style?: any }) {
    const pdfType = usePdfType();
    const { head, children, style } = props;

    return (
        <View style={{ ...style }}>
            <View style={{ justifyContent: 'flex-start', flexDirection: 'row' }}>
                <IconPoint
                    style={{
                        marginTop: 1,
                        marginRight: 4,
                        ...(pdfType === 'ms'
                            ? {
                                  marginTop: 3,
                              }
                            : {}),
                    }}
                />
                <View style={{ fontSize: 16 }}>{head}</View>
            </View>
            <View style={{ ...fontSize(12), marginTop: 12 }}>{children}</View>
        </View>
    );
}

export default Section;
